// extracted by mini-css-extract-plugin
export default {"container":"Card_container__ouyrA","name":"Card_name__ZvLf4","button":"Card_button__s0VBY"};